import React from 'react';
import { TABLE_COLUMNS } from '../data/columnConfig';
import { tableStyles } from '../styles/TableStyles';
import SortIndicator from './SortIndicator';
import QueueStatus from './QueueStatus';
import ListingTableRow from './ListingTableRow';

const ListingsTable = ({
  displayedListings,
  fetchedPropertyData,
  expandedRows,
  requestQueue,
  sortConfig,
  onRequestSort,
  onToggleExpansion,
  onAddressClick,
  onZillowClick,
  onSummaryClick,
  onPropertyDetailsClick,
  onResidentDetailsClick,
  loading
}) => {
  const handleHeaderClick = (columnKey) => {
    onRequestSort(columnKey);
  };

  return (
    <div className="bg-[#ffffff] overflow-hidden shadow-lg border border-[#96ffa8] rounded-lg">
      {requestQueue.length > 0 && (
        <div className="px-3 py-2">
          <QueueStatus requestQueue={requestQueue} />
        </div>
      )}
      
      <div className="table-container">
        <style>{tableStyles}</style>
        <table className="fixed-table divide-y divide-gray-200">
          <thead className="bg-[#e6ffea]">
            <tr>
              {TABLE_COLUMNS.map((column) => (
                <th 
                  key={column.key}
                  className={`${column.className} px-4 py-4 text-left text-xs font-medium text-black uppercase tracking-wider cursor-pointer`}
                  onClick={() => handleHeaderClick(column.key)}
                >
                  <div className="flex items-center">
                    {column.label} 
                    <SortIndicator sortConfig={sortConfig} columnKey={column.key} />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          
          <tbody className="bg-white divide-y divide-gray-200">
            {displayedListings.map((listing, index) => {
              const listingId = listing.id || listing.property_id;
              const isExpanded = expandedRows[listingId] || false;
              const propertyData = fetchedPropertyData[listingId];
              
              return (
                <ListingTableRow
                  key={listingId || index}
                  listing={listing}
                  propertyData={propertyData}
                  isExpanded={isExpanded}
                  onToggleExpansion={onToggleExpansion}
                  onAddressClick={onAddressClick}
                  onZillowClick={onZillowClick}
                  onSummaryClick={onSummaryClick}
                  onPropertyDetailsClick={onPropertyDetailsClick}
                  onResidentDetailsClick={onResidentDetailsClick}
                />
              );
            })}
            
            {displayedListings.length === 0 && (
              <tr>
                <td colSpan={6} className="px-6 py-8 text-center text-gray-500 bg-[#f0fff3]">
                  {loading ? (
                    <>
                      <div className="animate-spin mx-auto h-8 w-8 border-4 border-[#96ffa8] border-t-transparent rounded-full"></div>
                      <p className="mt-4 text-sm">Loading foreclosure listings...</p>
                    </>
                  ) : (
                    <>
                      <svg className="mx-auto h-12 w-12 text-[#96ffa8]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <p className="mt-2 text-sm">No foreclosure listings found matching your filters.</p>
                      <p className="text-sm">Try adjusting your search criteria or check back later.</p>
                    </>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListingsTable;